import { BaseDto } from '@/shared/dtos/base-dto';

export class kpis_actuacion extends BaseDto {
    public nombre !: string;
    public unidades !: string;
    public resultado_previsto !: number;
    public id_actuacion !: number;
    public descripcion !:string;
 } 
